var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x82\xBB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M19.52 47.808C19.52 54.08 21.76 57.216 33.664 57.216C41.664 57.216 48.064 56.704 53.76 55.872L53.952 50.368C47.616 51.648 41.408 52.288 33.984 52.288C26.368 52.288 24.704 50.88 24.704 46.464C24.704 40.128 24.704 19.2 24.704 12.48C24.704 10.624 24.896 8.44801 25.152 6.59201H19.136C19.456 8.44801 19.52 10.56 19.52 12.48C19.52 19.264 19.52 41.92 19.52 47.808Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M22 6.5C22 48.5 21.5 50.5 23.5 52.5C25.5 54.5 34 56 54.5 53",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M52.928 16.256L56.704 19.2C56.192 19.904 55.552 20.992 55.104 21.76C52.16 27.072 47.168 35.136 41.984 40.384L37.568 37.76C42.368 33.344 47.04 26.304 48.96 22.528C46.976 22.912 12.48 29.824 4.8 31.488L3.776 26.112C11.968 25.152 44.672 18.56 49.536 17.408C50.88 17.088 52.16 16.704 52.928 16.256Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M4 29L53.5 19C49.2537 27.4601 46.1122 31.92 39.5 39.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSe);
export default __webpack_public_path__ + "static/media/se.6ec5437b3bd8fe3e0ec87481270254a7.svg";
export { ForwardRef as ReactComponent };